import { useMutation } from "@tanstack/react-query";
import { deletePerkUsers, exportPerkUsers } from ".";

export const useDeleteTotalRewardsPerkUsers = (companyId: string) =>
  useMutation({
    mutationFn: async (formData: string[]) =>
      deletePerkUsers(formData, companyId),
  });

export const useExportTotalRewardsPerkUsers = () =>
  useMutation({
    mutationFn: async (payload: unknown) => exportPerkUsers(payload),
  });
